import { useMemo, useState } from 'react'
import { getColumns, getFilters, toolbarActions } from './helpers'
import { makeCoreGetFileRequest, makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { Table } from 'components/core-ui/Table'
import { formatAndDownloadResponse } from 'utils/helpers'
import { DownloadIcon, ViewActionIcon } from 'icons'
import { useNavigate } from 'react-router-dom'
import {
  getDepositOptions,
  getHubOptions,
  getParentSocietyOptions,
  getScreenPermissions,
  getShopOptions
} from 'components/shop-reception/admin/api'
import { SCREENS } from 'components/shop-reception/admin/constants'

const TasksTable = ({ type }) => {
  const [tableItems, setTableItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [isExcelExportLoading, setIsExcelExportLoading] = useState<boolean>(false)

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const { data: permissions } = getScreenPermissions(
    showNotification,
    SCREENS.PACKAGING_RETURN_LITIGATION
  )

  const columns = useMemo(() => getColumns(permissions?.canView, type), [])

  const { data: shopOptions } = getShopOptions(showNotification)
  const { data: hubOptions } = getHubOptions(showNotification)
  const { data: depositOptions } = getDepositOptions(showNotification)
  const { data: parentSocietyOptions } = getParentSocietyOptions(showNotification)

  const filters = useMemo(
    () =>
      getFilters(
        depositOptions || [],
        hubOptions || [],
        shopOptions || [],
        parentSocietyOptions || []
      ),
    [depositOptions, hubOptions, shopOptions, parentSocietyOptions]
  )

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: `/shop-reception/return-litigation/${type}`,
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const exportFileExcel = async (tableState, e) => {
    setIsExcelExportLoading(true)
    const { filters, order, orderBy } = tableState
    const url = toTableGETUrl({
      url: `/shop-reception/return-litigation/${type}/export`,
      tableFilters: filters,
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response);
      setIsExcelExportLoading(false)
    } catch (error) {
      setIsExcelExportLoading(false)
      showNotification({
        message: `A aparut o eroare la descarcarea fisierului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const toolbar = useMemo(() => toolbarActions({
      totalCount,
      exportFileExcel: exportFileExcel,
      isExcelExportLoading }),
    [totalCount, isExcelExportLoading])

  return (
    <Table
      hideCheckbox
      columns={columns}
      items={tableItems}
      fetchData={fetchData}
      isLoading={isLoading}
      totalCount={totalCount}
      shouldRefreshData={shouldRefreshData}
      setShouldRefreshData={setShouldRefreshData}
      toolbarActions={toolbar}
      rowActions={[
        {
          label: 'Detalii',
          labelColor: 'white',
          typographyVariant: 'medium',
          backgroundColor: '#16a085',
          desktopIcon: <ViewActionIcon />,
          onClick: (e, rowId) => {
            navigate(`/shop-reception/package/storeReturnsDisputes/${rowId}`, { state: type })
          }
        }
      ]}
      rowActionsWidth="130px"
      filters={filters}
      filtersButtonLabel="Filtre"
      filtersLabel="Filtre"
      appliedFiltersLabel="Filtre aplicate"
      cancelFiltersButtonLabel="Anuleaza"
      applyFiltersButtonLabel="Aplica"
      rowsPerPage={10}
      rowsPerPageOptions={[10, 25, 50]}
    />
  )
}

export default TasksTable
